import i18n from 'i18n-js';
import { scale } from '@components/frame';
import { setSecureValue } from '@helpers';
import { Perspective } from '@v2/pages/common/enums';
import { ToolsDetailsScreenName } from '@v2/pages/tools/details/navigation/config';
import { ToolsDetailsScreen } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { trackSearchResultTapped } from '@services/tracking';
import { HandleToolClickParams, ToolItem } from '@components/search/tools/types';

export const buildNavigationParams = (item: ToolItem) => ({
  mainScreen: ToolsDetailsScreenName,
  subScreen: ToolsDetailsScreen.TOOLS,
  params: {
    perspective: Perspective.TOOLS,
    toolId: item.toolId,
  },
});

export const buildRecentlyViewedEntry = (item: ToolItem) => ({
  ...item,
  itemType: 'Tool',
  itemDescription: item.toolName,
  itemMemo: item.description,
  itemId: item.toolId,
});

export const handleToolClick = ({
  item,
  isPopupMode,
  onItemSelect,
  attachMode,
  attachImageId,
  navigateToMainDetailsScreen,
  recentlyViewed,
  setRecentlyViewed,
}: HandleToolClickParams) => {
  trackSearchResultTapped('Tool');

  if (isPopupMode && onItemSelect) {
    onItemSelect(item, 'Tool');
    return;
  }

  if (attachMode && attachImageId) {
    return;
  }

  const exist = recentlyViewed.find((i: any) => i.itemId === item.toolId && i.itemType === 'Tool');
  if (!exist) {
    const d = [buildRecentlyViewedEntry(item), ...recentlyViewed];
    setRecentlyViewed(d);
    setSecureValue('recentlyViewed', JSON.stringify(d));
  }

  navigateToMainDetailsScreen(buildNavigationParams(item));
};

export const getDataGridColumns = (effectiveWidth: number) => [
  {
    field: 'toolName',
    headerName: i18n.t('Tool'),
    align: 'left' as const,
    width: scale(effectiveWidth / 5),
    sortable: true,
    filterable: true,
  },
  {
    field: 'description',
    headerName: i18n.t('Description'),
    align: 'left' as const,
    width: scale(effectiveWidth / 5),
    sortable: true,
    filterable: true,
  },
  {
    field: 'stickoutUM',
    headerName: i18n.t('Stick Out'),
    align: 'left' as const,
    width: scale(effectiveWidth / 5),
    sortable: true,
    filterable: true,
  },
  {
    field: 'ncFileCount',
    headerName: i18n.t('NC File Count'),
    align: 'left' as const,
    width: scale(effectiveWidth / 5),
    sortable: true,
    filterable: true,
  },
  {
    field: 'memo',
    headerName: i18n.t('Memo'),
    align: 'left' as const,
    width: scale(effectiveWidth / 4),
    sortable: true,
    filterable: true,
  },
];
